import { render, staticRenderFns } from "./loginMix.vue?vue&type=template&id=3956952c&scoped=true"
import script from "./loginMix.vue?vue&type=script&lang=js"
export * from "./loginMix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3956952c",
  null
  
)

export default component.exports